// Generic 'User' invalidations still refetch this; cohort tag changes target it alone.
export const MEMBERS_TABLE_TAG = { id: 'MEMBERS_TABLE', type: 'User' } as const;
